const isTouchDevice = () => 'ontouchstart' in window;

function shouldApplyAttribute(shouldReverseLogic) {
  return shouldReverseLogic
    ? !isTouchDevice()
    : isTouchDevice();
}

export default {
  bind: (el, binding) => {
    const { reverse } = binding.modifiers;

    if (shouldApplyAttribute(reverse)) {
      const elToModify = el.querySelector('[data-inheritattrs]') || el;
      const propToAdd = binding.arg;
      const { value } = binding;

      elToModify.setAttribute(propToAdd, value);
    }
  },
};
